'use client'
import { useTranslations } from 'next-intl';

export const RotateDevice = () => {
	const t = useTranslations('General');

	return (
		<div className="rotate-device">
			<div className="empty">
				<div className="empty__img empty__img--rotate" />
				<div className="empty__text">
					<p>
						{t('rotate')}
					</p>
				</div>
			</div>
		</div>
	)
}